<div class="footer text-gray-300">
  <div class="container mx-auto max-w-7xl grid grid-cols-1 md:grid-cols-10 gap-4">
    <div class="company-info col-span-1 md:col-span-3">
      <img [src]="logoLink" alt="Wahler Logo" class="logo" />
      <div class="opacity-50">
        <p>{{ address }}</p>
        <p>{{ phone }}</p>
      </div>
      <a [href]="'mailto:' + mail">{{ mail }}</a>
      <div class="social-icons mt-4 flex">
        <a [href]="facebookLink" class="pi pi-facebook text-xl mr-3" appLinkTabOpener
          ><span style="display: none">Facebook</span></a
        >
        <a [href]="linkedInLink" class="pi pi-linkedin text-xl" appLinkTabOpener
          ><span style="display: none">Linked In</span></a
        >
      </div>

      <div class="copyright mt-4 opacity-50">
        <p>{{ 'footer.copyright' | transloco }}</p>
      </div>
    </div>

    <div class="footer-links-wrapper col-span-1 md:col-span-2">
      <h5>{{ 'footer.company' | transloco }}</h5>
      @for (item of linksByCategory['Company']; track item.id) {
        <a [href]="item.url" appLinkTabOpener>{{ item.translation_key | transloco }}</a>
      }
    </div>

    <div class="footer-links-wrapper col-span-1 md:col-span-2">
      <h5>{{ 'footer.product' | transloco }}</h5>
      @for (item of linksByCategory['Product']; track item.id) {
        <a [href]="item.url" appLinkTabOpener>{{ item.translation_key | transloco }}</a>
      }
    </div>

    <div class="footer-links-wrapper col-span-1 md:col-span-3">
      <h5>{{ 'footer.legal' | transloco }}</h5>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="col-span-2 md:col-span-1">
          @for (item of linksByCategory['Legal and Data Protection 1']; track item.id) {
            <a [href]="item.url" appLinkTabOpener>{{ item.translation_key | transloco }}</a>
          }
        </div>
        <div class="col-span-2 md:col-span-1">
          @for (item of linksByCategory['Legal and Data Protection 2']; track item.id) {
            <a [href]="item.url" appLinkTabOpener>{{ item.translation_key | transloco }}</a>
          }
        </div>
      </div>
    </div>
  </div>
</div>
